import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import enTranslations from './locales/en.json';
import lgTranslations from './locales/lg.json';
import swTranslations from './locales/sw.json';
import { LANG_STORAGE_KEY, readStoredLanguage } from './navigation/storedLanguage';

const resources = {
  en: {
    translation: enTranslations
  },
  lg: {
    translation: lgTranslations
  },
  sw: {
    translation: swTranslations
  }
};

function initialLanguage(): 'en' | 'lg' | 'sw' {
  try {
    return readStoredLanguage(window.localStorage.getItem(LANG_STORAGE_KEY));
  } catch {
    return 'en';
  }
}

// Screen readers pronounce the page in the language it is shown in (WCAG 3.1.1).
i18n.on('languageChanged', (lng) => {
  document.documentElement.lang = lng;
});

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: initialLanguage(),
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
